export default "__VITE_ASSET__4nN4h4w$__"